export const servicesData = {
  fr: {
    pageTitle: 'Nos Services',
    intro: 'Chez Glow & You, chaque accompagnement est pensé pour vous aider à révéler votre identité visuelle unique — celle qui vous ressemble vraiment, celle qui vous fait rayonner.',
    freeConsultation: 'CONSULTATION DÉCOUVERTE OFFERTE 20 MINUTES EN VISIO',
    bookButton: 'RÉSERVER MA SÉANCE',
    bookFreeConsult: 'RÉSERVER MA CONSULTATION GRATUITE',
    
    packages: [
      {
        id: 'formule-01',
        number: 'FORMULE 01',
        name: 'Éveil de ton Image',
        nameEN: 'FIND YOUR GLOW',
        duration: '3h30',
        description: 'Pour celles et ceux qui veulent comprendre leur identité visuelle — leur style, leur morphologie, leurs couleurs — et repartir avec une direction claire et concrète.',
        forYouIf: [
          'Vous ne savez plus quoi porter ni comment vous habiller',
          'Vous voulez comprendre ce qui vous met en valeur (et ce qui ne fonctionne pas)',
          'Vous cherchez une base solide pour repartir du bon pied'
        ],
        sessions: [
          'Entretien découverte & analyse de style (30-40 min)',
          'Morphologie & silhouette (1h)',
          'Colorimétrie — votre palette idéale (1h)',
          'Synthèse & questions (15 min)'
        ],
        deliverables: [
          'Guide PDF personnalisé complet',
          'Nuancier colorimétrie format numérique',
          'Fiche morphologie — ce qui vous va / ce qui est à éviter concrets'
        ],
        pricing: {
          market: { visio: '~280 $', presentiel: '~320 $' },
          regular: { visio: '175 $', presentiel: '229 $' },
          launch: { visio: '157 $', presentiel: '206 $' }
        }
      },
      {
        id: 'formule-02',
        number: 'FORMULE 02',
        name: 'Harmonie & Style',
        nameEN: 'STYLE IN HARMONY',
        duration: 'Séance 1: 3h30 / Séance 2: 2h',
        description: 'Pour celles et ceux qui veulent non seulement se découvrir, mais aussi transformer leur garde-robe en un espace cohérent, fonctionnel et aligné avec qui ils et elles sont.',
        forYouIf: [
          'Vous avez une garde-robe pleine mais vous ne savez pas quoi porter',
          'Vous voulez du concret : tri, capsule wardrobe, liste d\'achats',
          'Vous êtes prêt·e à faire le ménage dans vos vêtements avec bienveillance'
        ],
        sessions: [
          'Séance 1 : Entretien + Analyse de style + Morphologie + Colorimétrie',
          'Séance 2 : Tri de garde-robe guidé + Construction de votre garde-robe capsule + Liste d\'achats ciblée'
        ],
        deliverables: [
          'Tout ce qui est inclus dans Éveil de ton Image',
          'Un dressing allégé, cohérent et aligné avec vous',
          'Une garde-robe capsule sur mesure',
          'Une liste d\'achats priorisée & ciblée'
        ],
        pricing: {
          market: { visio: '~500 $', presentiel: '~650 $' },
          regular: { visio: '299 $', presentiel: '399 $' },
          launch: { visio: '269 $', presentiel: '359 $' }
        }
      },
      {
        id: 'formule-03',
        number: 'FORMULE 03',
        name: 'Révélation Glow & You',
        nameEN: 'TOTAL GLOW',
        duration: 'Séance 1: 3h30 / Séance 2: 2h / Séance 3: 1h30',
        description: 'L\'accompagnement complet. Vous repartez avec une garde-robe qui vous ressemble, des pièces choisies avec intention, et un carnet de style pour vous guider au quotidien.',
        forYouIf: [
          'Vous voulez une transformation complète de votre image',
          'Vous voulez être accompagné·e dans vos achats (magasinage accompagné)',
          'Vous cherchez un suivi personnalisé et des outils concrets pour rester autonome'
        ],
        sessions: [
          'Séance 1 : Entretien + Analyse de style + Morphologie + Colorimétrie',
          'Séance 2 : Tri de garde-robe guidé + Garde-robe capsule + Liste d\'achats',
          'Séance 3 : Magasinage accompagné — boutiques préparées en amont, looks essayés ensemble'
        ],
        deliverables: [
          'Tout ce qui est inclus dans Harmonie & Style',
          'Des achats faits avec intention, pas avec compulsion',
          'Carnet de style complet + nuancier imprimé',
          'Suivi par message pendant 2 semaines'
        ],
        pricing: {
          market: { visio: '~750 $', presentiel: '~900 $' },
          regular: { visio: '449 $', presentiel: '599 $' },
          launch: { visio: '404 $', presentiel: '539 $' }
        }
      },
      {
        id: 'formule-mariee',
        number: 'FORMULE MARIÉE',
        name: 'Éclat Mariée',
        nameEN: 'BRIDAL GLOW',
        duration: 'Séance 1: 3h30 / Séance 2: 1h30 / Séance 3: 1h',
        description: 'Pour celles et ceux qui veulent rayonner le jour de leur mariage — de la robe aux accessoires, en passant par la coiffure et le maquillage adaptés à leur colorimétrie.',
        forYouIf: [
          'Vous cherchez LA robe qui vous mettra en valeur (pas juste une belle robe)',
          'Vous voulez un look cohérent de la tête aux pieds',
          'Vous voulez être guidé·e dans vos choix sans vous perdre dans les options'
        ],
        sessions: [
          'Séance 1 : Entretien + définition du style mariée + Morphologie + Colorimétrie adaptée au jour J',
          'Séance 2 : Accompagnement boutiques — robe, accessoires, looks essayés ensemble',
          'Séance 3 : Finalisation du carnet de style + conseils coiffure & maquillage selon votre colorimétrie'
        ],
        deliverables: [
          'Carnet de style PDF complet — vision du jour J de la tête aux pieds',
          'Nuancier colorimétrie adapté à votre tenue',
          'Conseils coiffure & maquillage personnalisés'
        ],
        pricing: {
          market: { visio: '~600 $', presentiel: '~750 $' },
          regular: { visio: '349 $', presentiel: '449 $' },
          launch: { visio: '314 $', presentiel: '404 $' }
        }
      }
    ],
    
    alaCarte: {
      title: 'Services À La Carte',
      intro: 'Vous avez besoin d\'un service spécifique ? Choisissez exactement ce dont vous avez besoin, sans engagement.',
      services: [
        {
          id: 'style-analysis',
          name: 'Analyse de Style',
          nameEN: 'Style Analysis',
          duration: '1h',
          description: 'Pour celles et ceux qui veulent identifier leur direction de style et savoir quoi porter selon leur personnalité.',
          deliverables: 'Mini guide PDF + direction de style claire.',
          pricing: {
            market: { visio: '~120 $', presentiel: '~140 $' },
            regular: { visio: '75 $', presentiel: '85 $' },
            launch: { visio: '67 $', presentiel: '76 $' }
          }
        },
        {
          id: 'colorimetry',
          name: 'Colorimétrie',
          nameEN: 'Color Analysis',
          duration: '1h',
          description: 'Pour celles et ceux qui veulent connaître leurs couleurs idéales et arrêter de porter des teintes qui les ternissent.',
          deliverables: 'Nuancier numérique personnalisé + règles de combinaison.',
          pricing: {
            market: { visio: '~140 $', presentiel: '~160 $' },
            regular: { visio: '75 $', presentiel: '99 $' },
            launch: { visio: '67 $', presentiel: '89 $' }
          }
        },
        {
          id: 'morphology',
          name: 'Morphologie',
          nameEN: 'Body Shape Analysis',
          duration: '1h',
          description: 'Pour celles et ceux qui veulent comprendre leur silhouette et porter des coupes qui les mettent en valeur.',
          deliverables: 'Fiche morphologie avec ce qui vous va / ce qui est à éviter concrets.',
          pricing: {
            market: { visio: '~120 $', presentiel: '~140 $' },
            regular: { visio: '65 $', presentiel: '85 $' },
            launch: { visio: '58 $', presentiel: '76 $' }
          }
        },
        {
          id: 'wardrobe-audit',
          name: 'Audit du Dressing',
          nameEN: 'Wardrobe Audit',
          duration: '1h',
          description: 'Pour celles et ceux qui veulent un diagnostic complet de leur garde-robe actuelle et savoir ce qui fonctionne.',
          deliverables: 'Rapport détaillé + recommandations ciblées.',
          pricing: {
            market: { visio: '~120 $', presentiel: '~150 $' },
            regular: { visio: '85 $', presentiel: '109 $' },
            launch: { visio: '76 $', presentiel: '98 $' }
          }
        },
        {
          id: 'wardrobe-edit',
          name: 'Tri du Dressing',
          nameEN: 'Wardrobe Edit',
          duration: '1h30',
          description: 'Pour celles et ceux qui veulent faire le tri dans leur garde-robe avec bienveillance et stratégie.',
          deliverables: 'Un dressing allégé, cohérent et fonctionnel.',
          pricing: {
            market: { visio: '~200 $', presentiel: '~320 $' },
            regular: { visio: '109 $', presentiel: '149 $' },
            launch: { visio: '98 $', presentiel: '134 $' }
          }
        },
        {
          id: 'capsule-wardrobe',
          name: 'Garde-Robe Capsule',
          nameEN: 'Capsule Wardrobe',
          duration: '1h',
          description: 'Pour celles et ceux qui veulent créer une garde-robe capsule fonctionnelle et cohérente.',
          deliverables: 'Sélection de pièces essentielles + guide de combinaisons.',
          pricing: {
            market: { visio: '~120 $', presentiel: '~150 $' },
            regular: { visio: '85 $', presentiel: '109 $' },
            launch: { visio: '76 $', presentiel: '98 $' }
          }
        },
        {
          id: 'personal-shopping',
          name: 'Magasinage Accompagné',
          nameEN: 'Personal Shopping',
          duration: '1h30',
          description: 'Pour celles et ceux qui veulent être guidé·es dans leurs achats et arrêter d\'acheter par compulsion. Aucune obligation d\'achat.',
          deliverables: 'Des achats faits avec intention, pas avec compulsion.',
          pricing: {
            market: { visio: '~150 $', presentiel: '~350 $' },
            regular: { visio: '109 $', presentiel: '149 $' },
            launch: { visio: '98 $', presentiel: '134 $' }
          }
        },
        {
          id: 'event-styling',
          name: 'Tenue Événement',
          nameEN: 'Event Styling',
          duration: '1h',
          description: 'Pour celles et ceux qui ont un événement important et veulent un look impeccable sans stress.',
          deliverables: 'Tenues validées, accessoires choisis, zéro stress le jour J.',
          pricing: {
            market: { visio: '~150 $', presentiel: '~200 $' },
            regular: { visio: '85 $', presentiel: '109 $' },
            launch: { visio: '76 $', presentiel: '98 $' }
          }
        },
        {
          id: 'individual-workshop',
          name: 'Atelier Individuel',
          nameEN: 'Individual Workshop',
          duration: '1h30',
          description: 'Pour celles et ceux qui veulent apprendre à s\'habiller de façon autonome avec des outils concrets.',
          deliverables: 'Support pédagogique personnalisé + outils pour être autonome.',
          pricing: {
            market: { visio: '~150 $', presentiel: '~200 $' },
            regular: { visio: '109 $', presentiel: '139 $' },
            launch: { visio: '98 $', presentiel: '125 $' }
          }
        },
        {
          id: 'group-workshop',
          name: 'Atelier en Groupe',
          nameEN: 'Group Workshop',
          duration: '1h30',
          note: 'MIN. 4 PERSONNES',
          description: 'Pour celles et ceux qui veulent découvrir les bases du style en groupe, dans une ambiance bienveillante.',
          deliverables: 'Les clés essentielles pour commencer à habiller votre identité.',
          pricing: {
            market: { visio: '~80 $/pers.', presentiel: '~100 $/pers.' },
            regular: { visio: '49 $/pers.', presentiel: '69 $/pers.' },
            launch: { visio: '44 $/pers.', presentiel: '62 $/pers.' }
          }
        }
      ]
    }
  },
  en: {
    pageTitle: 'Our Services',
    intro: 'At Glow & You, each service is designed to help you reveal your unique visual identity — the one that truly reflects you, the one that makes you shine.',
    freeConsultation: 'FREE 20-MINUTE DISCOVERY CONSULTATION VIA VIDEO',
    bookButton: 'BOOK MY SESSION',
    bookFreeConsult: 'BOOK MY FREE CONSULTATION',
    
    packages: [
      {
        id: 'formule-01',
        number: 'PACKAGE 01',
        name: 'Find Your Glow',
        nameEN: 'FIND YOUR GLOW',
        duration: '3h30',
        description: 'For those who want to understand their visual identity — their style, body shape, colors — and leave with a clear, concrete direction.',
        forYouIf: [
          'You don\'t know what to wear or how to dress anymore',
          'You want to understand what flatters you (and what doesn\'t)',
          'You\'re looking for a solid foundation to start fresh'
        ],
        sessions: [
          'Discovery interview & style analysis (30-40 min)',
          'Body shape & silhouette (1h)',
          'Color analysis — your ideal palette (1h)',
          'Summary & questions (15 min)'
        ],
        deliverables: [
          'Complete personalized PDF guide',
          'Digital color palette chart',
          'Body shape guide — concrete do\'s & don\'ts'
        ],
        pricing: {
          market: { visio: '~$280', presentiel: '~$320' },
          regular: { visio: '$175', presentiel: '$229' },
          launch: { visio: '$157', presentiel: '$206' }
        }
      },
      {
        id: 'formule-02',
        number: 'PACKAGE 02',
        name: 'Style in Harmony',
        nameEN: 'STYLE IN HARMONY',
        duration: 'Session 1: 3h30 / Session 2: 2h',
        description: 'For those who want not only to discover themselves, but also transform their wardrobe into a coherent, functional space aligned with who they are.',
        forYouIf: [
          'You have a closet full of clothes but don\'t know what to wear',
          'You want concrete results: decluttering, capsule wardrobe, shopping list',
          'You\'re ready to mindfully edit your wardrobe'
        ],
        sessions: [
          'Session 1: Interview + Style analysis + Body shape + Color analysis',
          'Session 2: Guided wardrobe decluttering + Building your capsule wardrobe + Targeted shopping list'
        ],
        deliverables: [
          'Everything included in Find Your Glow',
          'A streamlined, coherent wardrobe aligned with you',
          'A custom capsule wardrobe',
          'A prioritized & targeted shopping list'
        ],
        pricing: {
          market: { visio: '~$500', presentiel: '~$650' },
          regular: { visio: '$299', presentiel: '$399' },
          launch: { visio: '$269', presentiel: '$359' }
        }
      },
      {
        id: 'formule-03',
        number: 'PACKAGE 03',
        name: 'Total Glow',
        nameEN: 'TOTAL GLOW',
        duration: 'Session 1: 3h30 / Session 2: 2h / Session 3: 1h30',
        description: 'The complete transformation. You leave with a wardrobe that reflects you, intentionally chosen pieces, and a style guide for daily guidance.',
        forYouIf: [
          'You want a complete image transformation',
          'You want to be guided through your shopping (personal shopping)',
          'You\'re looking for personalized follow-up and concrete tools to stay autonomous'
        ],
        sessions: [
          'Session 1: Interview + Style analysis + Body shape + Color analysis',
          'Session 2: Guided wardrobe decluttering + Custom capsule wardrobe + Shopping list',
          'Session 3: Personal shopping session — shops prepared in advance, outfits tried together'
        ],
        deliverables: [
          'Everything included in Style in Harmony',
          'Intentional purchases, not impulsive ones',
          'Complete style book + printed color palette',
          '2-week message follow-up'
        ],
        pricing: {
          market: { visio: '~$750', presentiel: '~$900' },
          regular: { visio: '$449', presentiel: '$599' },
          launch: { visio: '$404', presentiel: '$539' }
        }
      },
      {
        id: 'formule-mariee',
        number: 'BRIDAL PACKAGE',
        name: 'Bridal Glow',
        nameEN: 'BRIDAL GLOW',
        duration: 'Session 1: 3h30 / Session 2: 1h30 / Session 3: 1h',
        description: 'For those who want to shine on their wedding day — from dress to accessories, including hair and makeup adapted to their color palette.',
        forYouIf: [
          'You\'re looking for THE dress that flatters you (not just a beautiful dress)',
          'You want a cohesive look from head to toe',
          'You want guidance in your choices without getting lost in options'
        ],
        sessions: [
          'Session 1: Interview + bridal style definition + Body shape + Color analysis adapted to your big day',
          'Session 2: Boutique accompaniment — dress, accessories, outfits tried together',
          'Session 3: Style book finalization + hair & makeup advice according to your color palette'
        ],
        deliverables: [
          'Complete PDF style book — vision of your big day from head to toe',
          'Color palette adapted to your outfit',
          'Personalized hair & makeup recommendations'
        ],
        pricing: {
          market: { visio: '~$600', presentiel: '~$750' },
          regular: { visio: '$349', presentiel: '$449' },
          launch: { visio: '$314', presentiel: '$404' }
        }
      }
    ],
    
    alaCarte: {
      title: 'À La Carte Services',
      intro: 'Need a specific service? Choose exactly what you need, no commitment.',
      services: [
        {
          id: 'style-analysis',
          name: 'Style Analysis',
          nameEN: 'Style Analysis',
          duration: '1h',
          description: 'For those who want to identify their style direction and know what to wear according to their personality.',
          deliverables: 'Mini PDF guide + clear style direction.',
          pricing: {
            market: { visio: '~$120', presentiel: '~$140' },
            regular: { visio: '$75', presentiel: '$85' },
            launch: { visio: '$67', presentiel: '$76' }
          }
        },
        {
          id: 'colorimetry',
          name: 'Color Analysis',
          nameEN: 'Color Analysis',
          duration: '1h',
          description: 'For those who want to know their ideal colors and stop wearing shades that dull them.',
          deliverables: 'Personalized digital color palette + combination rules.',
          pricing: {
            market: { visio: '~$140', presentiel: '~$160' },
            regular: { visio: '$75', presentiel: '$99' },
            launch: { visio: '$67', presentiel: '$89' }
          }
        },
        {
          id: 'morphology',
          name: 'Body Shape Analysis',
          nameEN: 'Body Shape Analysis',
          duration: '1h',
          description: 'For those who want to understand their silhouette and wear cuts that flatter them.',
          deliverables: 'Body shape guide with concrete do\'s & don\'ts.',
          pricing: {
            market: { visio: '~$120', presentiel: '~$140' },
            regular: { visio: '$65', presentiel: '$85' },
            launch: { visio: '$58', presentiel: '$76' }
          }
        },
        {
          id: 'wardrobe-audit',
          name: 'Wardrobe Audit',
          nameEN: 'Wardrobe Audit',
          duration: '1h',
          description: 'For those who want a complete assessment of their current wardrobe and what works.',
          deliverables: 'Detailed report + targeted recommendations.',
          pricing: {
            market: { visio: '~$120', presentiel: '~$150' },
            regular: { visio: '$85', presentiel: '$109' },
            launch: { visio: '$76', presentiel: '$98' }
          }
        },
        {
          id: 'wardrobe-edit',
          name: 'Wardrobe Edit',
          nameEN: 'Wardrobe Edit',
          duration: '1h30',
          description: 'For those who want to declutter their wardrobe mindfully and strategically.',
          deliverables: 'A streamlined, coherent and functional closet.',
          pricing: {
            market: { visio: '~$200', presentiel: '~$320' },
            regular: { visio: '$109', presentiel: '$149' },
            launch: { visio: '$98', presentiel: '$134' }
          }
        },
        {
          id: 'capsule-wardrobe',
          name: 'Capsule Wardrobe',
          nameEN: 'Capsule Wardrobe',
          duration: '1h',
          description: 'For those who want to create a functional and cohesive capsule wardrobe.',
          deliverables: 'Selection of essential pieces + combination guide.',
          pricing: {
            market: { visio: '~$120', presentiel: '~$150' },
            regular: { visio: '$85', presentiel: '$109' },
            launch: { visio: '$76', presentiel: '$98' }
          }
        },
        {
          id: 'personal-shopping',
          name: 'Personal Shopping',
          nameEN: 'Personal Shopping',
          duration: '1h30',
          description: 'For those who want guidance in their purchases and want to stop buying impulsively. No purchase obligation.',
          deliverables: 'Intentional purchases, not impulsive ones.',
          pricing: {
            market: { visio: '~$150', presentiel: '~$350' },
            regular: { visio: '$109', presentiel: '$149' },
            launch: { visio: '$98', presentiel: '$134' }
          }
        },
        {
          id: 'event-styling',
          name: 'Event Styling',
          nameEN: 'Event Styling',
          duration: '1h',
          description: 'For those who have an important event and want an impeccable look without stress.',
          deliverables: 'Validated outfits, chosen accessories, zero stress on the day.',
          pricing: {
            market: { visio: '~$150', presentiel: '~$200' },
            regular: { visio: '$85', presentiel: '$109' },
            launch: { visio: '$76', presentiel: '$98' }
          }
        },
        {
          id: 'individual-workshop',
          name: 'Individual Workshop',
          nameEN: 'Individual Workshop',
          duration: '1h30',
          description: 'For those who want to learn to dress autonomously with concrete tools.',
          deliverables: 'Personalized learning materials + tools to be autonomous.',
          pricing: {
            market: { visio: '~$150', presentiel: '~$200' },
            regular: { visio: '$109', presentiel: '$139' },
            launch: { visio: '$98', presentiel: '$125' }
          }
        },
        {
          id: 'group-workshop',
          name: 'Group Workshop',
          nameEN: 'Group Workshop',
          duration: '1h30',
          note: 'MIN. 4 PEOPLE',
          description: 'For those who want to discover style basics in a group, in a supportive atmosphere.',
          deliverables: 'Essential keys to start dressing your identity.',
          pricing: {
            market: { visio: '~$80/person', presentiel: '~$100/person' },
            regular: { visio: '$49/person', presentiel: '$69/person' },
            launch: { visio: '$44/person', presentiel: '$62/person' }
          }
        }
      ]
    }
  }
};
